
export default class Footer {

	static getHolderSelectors = () => ['footer'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		document.querySelectorAll('a[href^="tel:"]').forEach(element => {
			element.href = element.href.replaceAll(/[\s()]/g, '').replaceAll(/ /g, '').replaceAll(/(\s)/g, '').replaceAll(/-/g, '');
		});

	}

}
